{
    "Accessibility menu": "Μενού Προσβασιμότητας",
    "Close": "Κλείσιμο",
    "Content adjustments": "Προσαρμογές Περιεχομένου",
    "Navigation adjustments": "Προσαρμογές Πλοήγησης",
    "Text Align": "Text Align",
    "Align Left": "Στοίχιση Αριστερά",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Προσαρμογή Μεγέθους Γραμματοσειράς",
    "Highlight Title": "Επισήμανση Τίτλου",
    "Highlight Links": "Επισήμανση Συνδέσμων",
    "Readable Font": "Αναγνώσιμη Γραμματοσειρά",
    "Colour adjustments": "Προσαρμογές Χρώματος",
    "Dark Contrast": "Σκούρη Αντίθεση",
    "Light Contrast": "Ανοιχτή Αντίθεση",
    "High Contrast": "Υψηλή Αντίθεση",
    "High Saturation": "Υψηλή Κορεσμός",
    "Low Saturation": "Χαμηλός Κορεσμός",
    "Monochrome": "Μονόχρωμο",
    "Tools": "Εργαλεία",
    "Reading Guide": "Οδηγός Ανάγνωσης",
    "Big Cursor": "Μεγάλος Δρομέας",
    "Increase Font Size": "Αύξηση Μεγέθους Γραμματοσειράς",
    "Decrease Font Size": "Μείωση Μεγέθους Γραμματοσειράς",
    "Letter Spacing": "Διάστημα Γραμμάτων",
    "Line Height": "Ύψος Γραμμής",
    "Font Weight": "Πάχος Γραμματοσειράς",
    "Dyslexia Font": "Γραμματοσειρά για Δυσλεξία",
    "Language": "Γλώσσα",
    "Accessibility widget": "Άνοιγμα Μενού Προσβασιμότητας",
    "Accessibility Profiles": "Προφίλ Προσβασιμότητας",
    "Cognitive Disability": "Γνωστική Αναπηρία",
    "Seizure Safe": "Ασφαλές για Επιληψία",
    "Accessibility statement": "Δήλωση Προσβασιμότητας",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Διακοπή Κινούμενων Εικόνων",
    "Reset all settings": "Επαναφορά ρυθμίσεων",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
